<div class="wrap">
  <app-svg-icon class="close-icon" name="close" (click)="popoverCtrl.dismiss()"></app-svg-icon>
  <div class="header">
    <div class="icon">
      <app-svg-icon [color]="'color-state-success'" name="info"></app-svg-icon>
    </div>
    <div class="text">
      {{ "@components.forgottenPasswordConfirmation.header" | translate }}
    </div>
  </div>

  <div class="content">
    <div class="message">
      {{
        "@components.forgottenPasswordConfirmation.content.message" | translate
      }}
    </div>
    <div class="message email">{{ email }}</div>
  </div>

  <app-action-button
    (click)="popoverCtrl.dismiss()"
    [label]="'@components.forgottenPasswordConfirmation.actionBtn' | translate"
  ></app-action-button>
</div>
